import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Line } from "react-chartjs-2";
import "chartjs-adapter-date-fns";
import { useToast } from "../../Utils/toastContext";

ChartJS.register(ArcElement, Tooltip, Legend);

const InvestmentProductDetails = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const location = useLocation();
  const data = [
    {
      category: {
        name: "Defensive",
        allocation: 38,
        products: [
          {
            name: "Australian Fixed Interest",
            allocation: 38,
            stocks: [
              {
                name: "Commonwealth Bank of Australia. Ordinary",
                allocation: 38,
                asx_code: "CBA",
                unit_price: 90.17,
                quantity: 38000,
                market_price: 3426460,
              },
            ],
          },
        ],
      },
    },
    {
      category: {
        name: "Growth",
        allocation: 60,
        products: [
          {
            name: "Australian Property",
            allocation: 20,
            stocks: [
              {
                name: "iShares S&P 500 AUD Hedged ETF",
                allocation: 20,
                asx_code: "IHV",
                unit_price: 81.81,
                quantity: 20000,
                market_price: 1636200,
              },
            ],
          },
          {
            name: "Global Shares",
            allocation: 40,
            stocks: [
              {
                name: "BetaShares Australian High Interest Cash ETF",
                allocation: 0,
                asx_code: "AAA",
                unit_price: 75.08,
                quantity: 0,
                market_price: 0,
              },
              {
                name: "BetaShares Australian High Interest Cash ETF",
                allocation: 30,
                asx_code: "AAA",
                unit_price: 75.08,
                quantity: 30000,
                market_price: 2252400,
              },
              {
                name: "BetaShares Australian High Interest Cash ETF",
                allocation: 10,
                asx_code: "AAA",
                unit_price: 75.08,
                quantity: 10000,
                market_price: 750800,
              },
            ],
          },
        ],
      },
    },
  ];
  const { from, investment_id } = location.state || {};

  const [filter, setFilter] = useState("details");
  const [selectedFilter, setSelectedFilter] = useState("5Y");

  const [refId, setRefId] = useState("12345");
  const [strategyType, setstrategyType] = useState("test");
  const [riskProfile, setRiskProfile] = useState("60.40");
  const [investmentType, setinvestmentType] = useState("sma");
  const [investmentManagerId, setInvestmentManagerId] = useState(0);
  const [subAdvisorAccount, setsubAdvisorAccount] = useState("");
  const [InvestmentManagerAccount, setInvestmentManagerAccount] = useState(0);
  const [subadvisorId, setSubadvisorId] = useState(0);
  const [platformId, setPlatformId] = useState(0);
  const [advisorId, setadvisorId] = useState(0);
  const [advisorAccount, setadvisorAccount] = useState(0);
  const [platformAccount, setplatformAccount] = useState(0);

  const [fundObjectives, setFundObjectives] = useState("");
  const [investments, setInvestments] = useState(["ASX ETFs", "LICs"]);
  const [growth, setGrowth] = useState(0);
  const [defensive, setDefensive] = useState(0);
  const navigate = useNavigate();
  const [isOpenDownload, setisOpenDownload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setfilteredData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [investmentManagerNamefromAPI, setInvestmentManagerNamefromAPI] =
    useState("");
  const [investmentManagerAccountfromAPI, setInvestmentManagerAccountfromAPI] =
    useState("");
  const [advisorIdfromAPI, setadvisorIdfromAPI] = useState("");
  const [advisorAccountfromAPI, setadvisorAccountfromAPI] = useState("");
  const [subadvisorIdfromAPI, setSubadvisorIdfromAPI] = useState("");
  const [subAdvisorAccountfromAPI, setsubAdvisorAccountfromAPI] = useState("");
  const [investmentProductName, setinvestmentProductName] = useState("");
  const [riskRating, setriskRating] = useState("");
  const [smaFees, setsmaFees] = useState("");
  const [advisorFeesUpdate, setadvisorFeesUpdate] = useState("");
  const [managerFeesUpdate, setmanagerFeesUpdate] = useState("");
  const [smaFeesUpdate, setsmaFeesUpdate] = useState("");
  const [isNewChangeFees, setisNewChangeFees] = useState(true);

  const [managerFees, setmanagerFees] = useState(0);
  const [advisorFees, setadvisorFees] = useState(0);
  const [subadvisorFees, setsubadvisorFees] = useState(0);
  const [strategyDate, setstrategyDate] = useState("");
  const [minimumInvestedAmount, setminimumInvestedAmount] = useState(0);
  const [investmentManagerNameView, setinvestmentManagerNameView] = useState(0);
  const [dateCreated, setdateCreated] = useState(0);
  const [strategyTypeView, setstrategyTypeView] = useState(0);
  const [newCategories, setNewCategories] = useState([]);
  const [preselectedManager, setPreselectedManager] = useState([]);
  const [totalCount, settotalCount] = useState(0);

  const [preselectedManagerAccount, setPreselectedManagerAccount] = useState(
    []
  );
  const [preselectedAdvisor, setPreselectedAdvisor] = useState([]);
  const [preselectedAdvisorAccount, setPreselectedAdvisorAccount] = useState(
    []
  );
  const [preselectedSubAdvisor, setPreselectedSubAdvisor] = useState([]);
  const [preselectedSubAdvisorAccount, setPreselectedSubAdvisorAccount] =
    useState([]);
  const [platformAccountfromAPI, setPlatformAccountfromAPI] = useState([]);
  const [platformIdfromAPI, setPlatformIdfromAPI] = useState([]);
  const [preselectedPlatform, setPreselectedPlatform] = useState([]);
  const [preselectedPlatformAccount, setPreselectedPlatformAccount] = useState(
    []
  );
  const [isNewChange, setisNewChange] = useState(true);
  const [stockPrices, setStockprices] = useState([]);
  const [totalPages, settotalPages] = useState(0);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenEdit, setisOpenEdit] = useState(false);
  const togglePopup = () => setIsOpen(!isOpen);
  const [isCurrentInvestorSelected, setIsCurrentInvestorSelected] =
    useState(true);
  const [clientId, setClientId] = useState("");
  const [isClientExist, setIsClientExist] = useState();
  const [clientName, setClientName] = useState("");
  const [creatorId, setCreatorId] = useState("");
  const [isCreatorExist, setIsCreatorExist] = useState();
  const [creatorName, setCreatorName] = useState("");
  const [investorClientFirstName, setInvestorClientFirstName] = useState("");
  const [investorClientLastName, setInvestorClientLastName] = useState("");
  const [investorClientEmail, setInvestorClientEmail] = useState("");
  const [investorClientPhone, setInvestorClientPhone] = useState("");
  const [investorClientAccountBalance, setInvestorClientAccountBalance] =
    useState("");
  const [investorClientAbn, setInvestorClientAbn] = useState("");
  const [isInvestorAvailable, setIsInvestorAvailable] = useState(false);
  const [investmentAmount, setInvestmentAmount] = useState(0);
  const [portfolioData, setPortfolioData] = useState([]);
  const [portfolioDataAvailable, setportfolioDataAvailable] = useState(false);
  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];
  const [filterStatus, setFilterStatus] = useState("");
  const [isOpenFilter, setIsOpenFilter] = useState(false);

  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 7,
    label: "10",
  });
  const handleFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const allFilteraStatus = [];
  allFilteraStatus.push({
    value: "approved",
    label: "Approved",
  });
  allFilteraStatus.push({
    value: "rejected",
    label: "Reject",
  });
  allFilteraStatus.push({
    value: "",
    label: "All",
  });

  const togglePopupEdit = () => setisOpenEdit(!isOpenEdit);
  const secondheaders = [
    "Investment Manager",
    "Date",
    "Strategy",
    "Growth",
    "Defensive",
  ];
  const investorheaders = [
    "Date",
    "Investor Name",
    "Investment Amount",
    "Cash Account",
  ];

  const [users, setUsers] = useState([]);
  const [donutdataGraph, setDonutData] = useState({});

  const [SettlementAccountData, setSettlementAccountData] = useState([]);
  const [SubAdvisorAccountData, setSubAdvisorAccountData] = useState([]);
  const [showRecords, setShowRecords] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [pastPerformance, setpastPerformance] = useState("");
  const [disclaimer, setDisclaimer] = useState("");
  const [copyright, setCopyright] = useState("");

  const [selected, setSelected] = useState("Download Report");
  const [selectedInvestorReport, setselectedInvestorReport] =
    useState("Download Report");
  const [isOpenInvestorDropdown, setisOpenInvestorDropdown] = useState(false);
  const [allocationGraphData, setfilteredGraphdata] = useState([]);
  const [totalInvestors, setTotalInvestors] = useState(0);
  const [totalInvestedAmount, setTotalInvestedAmount] = useState(0);
  const [investortableData, setInvestortableData] = useState([]);
  const [rawData, setrawData] = useState([]);

  const options = [
    { value: "pdf", label: "PDF", image: "/images/pdf-icon.png" },
    { value: "csv", label: "CSV", image: "/images/csv-icon.png" },
  ];

  const handleSelect = (option) => {
    setSelected(option.label);
    setisOpenDownload(false);
  };
  const handleSelectInvestorReport = (option) => {
    setselectedInvestorReport(option.label);
    setisOpenInvestorDropdown(false);
  };
  const handleSelectPlatform = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setPlatformId(selectedOption.value);
    setPreselectedPlatformAccount({});
    setplatformAccount(0);
    setisNewChange(false);
  };
  const calculateTotals = (items) => {
    return {
      totalCapital: items.reduce((sum, item) => sum + item.unit_price, 0),
      totalMarketPrice: items.reduce((sum, item) => sum + item.market_price, 0),
      totalShares: items.reduce((sum, item) => sum + item.quantity, 0),
      totalValue: items.reduce(
        (sum, item) => sum + item.market_price * item.quantity,
        0
      ),
      totalPercentage: items.reduce((sum, item) => sum + item.allocation, 0),
    };
  };

  const handleBlurClientId = () => {
    getClientName();
  };
  const handleBlurCreatorId = () => {
    getCreatorName();
  };
  const [InvestmentManagerAccountData, setInvestmentManagerAccountData] =
    useState([]);
  const [AdvisorAccountData, setAdvisorAccountData] = useState([]);
  useEffect(() => {
    getWalletAccountsByAdvisor();
  }, [advisorId]);
  const handleSelectSubAdvisorAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setsubAdvisorAccount(selectedOption.value);
    setisNewChange(false);
  };
  const handleSelectSubAdvisor = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setSubadvisorId(selectedOption.value);
    setPreselectedSubAdvisorAccount({});
    setsubAdvisorAccount(0);
    setisNewChange(false);
  };
  const handleSelectSettlementAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setplatformAccount(selectedOption.value);
    setisNewChange(false);
  };
  const labelsLine = rawData.map((item) => {
    const date = new Date(item.time); // Parse the date
    return date; // Return Date object (Chart.js can parse Date objects)
  });
  const formatDateList = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  const optionsLine = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        backgroundColor: "#3047EC",
        borderColor: "#4A90E2",
        borderWidth: 1,
        titleColor: "#AEC8FF",
        bodyColor: "white",
        callbacks: {
          title: (tooltipItems) => {
            // Format the title as MM/YYYY
            const date = new Date(tooltipItems[0].label);
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            return `${month}/${year}`;
          },
          label: (tooltipItem) => {
            // Format the label as $<value>
            return `$${tooltipItem.raw.toFixed(2)}`;
          },
        },
      },
      legend: { display: false },
    },
    scales: {
      x: {
        type: "time", // Ensure the x-axis uses time scale
        time: {
          unit: "month", // Display months
          tooltipFormat: "ll", // Tooltip format
        },
        grid: { drawOnChartArea: false, drawTicks: false },
        ticks: {
          display: true,
          color: "black",

          callback: function (value) {
            const date = new Date(value); // Parse the timestamp as a date
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            return `${month} ${year}`; // Display month and year on separate lines
          },
          font: {
            size: 12, // Adjust size to fit the labels properly
          },
          maxRotation: 0,
          minRotation: 0,
        },
        border: { color: "black" },
        afterFit: function (scale) {
          scale.height = 60; // Adjust the height to ensure space for two lines
        },
      },
      y: {
        grid: {
          drawOnChartArea: true, // Show grid lines on the chart area
          drawTicks: false, // Optionally hide ticks on grid lines
          color: "rgba(0, 0, 0, 0.1)", // Set the color of the grid lines (light gray)
          lineWidth: 1, // Set the line width of the grid lines
        },
        ticks: {
          callback: (value) => `${value.toFixed(2)}`,
          color: "black",
          padding: 10, // Add spacing for Y-axis labels
        },
        beginAtZero: false, // Optional: prevent starting at zero
        min: 0, // Adjust this value to add more space above the border
        offset: true, // Add extra space between the border and the graph
        border: { display: false },
      },
    },
  };
  const dataLine = {
    labels: labelsLine,
    datasets: [
      {
        label: "Price",
        data: stockPrices,
        borderColor: "#3047EC",
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) {
            return null; // Wait until the chart is fully rendered
          }

          const gradient = ctx.createLinearGradient(
            0,
            chartArea.top,
            0,
            chartArea.bottom
          );
          gradient.addColorStop(0, "rgba(74, 144, 226, 0.1)"); // Light blue at the top
          gradient.addColorStop(1, "white"); // White at the bottom

          return gradient;
        },
        tension: 0.4,
        fill: true,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
  };
  const getWalletAccountsBySubAdvisor = async () => {
    try {
      const response = await GetAPIcalls(`/v1/wallet/user/${subadvisorId}`);

      if (response.status == 200) {
        const SubAdvisorAccountData = [];
        response.data.forEach((profile) => {
          SubAdvisorAccountData.push({
            value: profile.id,
            label: profile.account_name,
          });
        });
        setSubAdvisorAccountData(SubAdvisorAccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setSubAdvisorAccountData([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    getWalletAccountsBySubAdvisor();
  }, [subadvisorId]);
  const getWalletAccountsByAdvisor = async () => {
    try {
      const response = await GetAPIcalls(`/v1/wallet/user/${advisorId}`);

      if (response.status == 200) {
        const AdvisorAccountData = [];
        response.data.forEach((profile) => {
          AdvisorAccountData.push({
            value: profile.id,
            label: profile.account_name,
          });
        });
        setAdvisorAccountData(AdvisorAccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setAdvisorAccountData([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getClientName = async () => {
    if (clientId == "") {
      setIsClientExist(false);
      setClientName("");
      return;
    }
    if (clientId == creatorId) {
      setIsClientExist(false);
      setClientName("");
      setIsInvestorAvailable(false);
      showToast("Client ID and Creator Id cannot be same", "error");
      return;
    }
    try {
      const response = await GetAPIcalls(`/v1/user/client-id/${clientId}`);

      if (response.status == 200) {
        setIsClientExist(true);
        setClientName(response.data.first_name + " " + response.data.last_name);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setIsClientExist(false);
          setClientName("No Such Client Found");
          setIsInvestorAvailable(false);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getCreatorName = async () => {
    if (creatorId == "") {
      setIsCreatorExist(false);
      setCreatorName("");
      return;
    }
    if (clientId == creatorId) {
      setIsClientExist(false);
      setClientName("");
      setIsInvestorAvailable(false);
      showToast("Client ID and Creator Id cannot be same", "error");
      return;
    }
    try {
      const response = await GetAPIcalls(`/v1/user/client-id/${creatorId}`);

      if (response.status == 200) {
        setIsCreatorExist(true);
        setCreatorName(
          response.data.first_name + " " + response.data.last_name
        );
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setIsCreatorExist(false);
          setCreatorName("No Such Creator Found");
          setIsInvestorAvailable(false);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    if (filter === "view") {
      fetchViewData();
    }
    if (filter === "details") {
      getInvestmentDetails();
    }
    if (filter === "investors") {
      getInvestorDetails();
    }
  }, [filter, selectedFilter, currentPage, showRecords, searchQuery]);
  const formatDate = (dateString) => {
    const date = new Date(dateString); // Convert string to Date object
    const day = String(date.getDate()).padStart(2, "0"); // Get day with leading zero
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get month (0-indexed) with leading zero
    const year = date.getFullYear(); // Get full year

    return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
  };
  const fetchViewData = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/investment/get/${investment_id}/view?period=${selectedFilter.toLocaleLowerCase()}`
      );

      if (response.status == 200) {
        setinvestmentManagerNameView(
          response.data.fact_sheet.investment_manager
        );
        setdateCreated(formatDate(response.data.fact_sheet.date_created));
        setstrategyTypeView(response.data.fact_sheet.strategy_type);
        setGrowth(response.data.fact_sheet.growth_percentage);
        setDefensive(response.data.fact_sheet.defensive_percentage);
        setFundObjectives(response.data.fact_sheet.fund_objective_and_process);
        //investment details
        setinvestmentProductName(
          response.data.investment_details.investment_product_name
        );
        setriskRating(response.data.investment_details.risk_rating);
        setRiskProfile(response.data.risk_profile);
        setGrowth(response.data.investment_details.growth_percentage);
        setDefensive(response.data.investment_details.defensive_percentage);
        setInvestments(response.data.investment_details.tags);
        setmanagerFees(response.data.investment_details.manager_fee_percentage);
        setadvisorFees(response.data.investment_details.advisor_fee_percentage);
        setsmaFees(response.data.investment_details.sma_fee_percentage);
        setsubadvisorFees(
          response.data.investment_details.sub_advisor_fee_percentage
        );
        setminimumInvestedAmount(
          response.data.investment_details.minimum_investment
        );
        setpastPerformance(response.data.past_performance);
        setCopyright(response.data.copy_rights);
        setDisclaimer(response.data.disclaimer);
        // current allocation
        setNewCategories(response.data.current_target_allocation);
        //allocation graph
        setfilteredGraphdata(response.data.product_percentage_allocation);
        setrawData(response.data.historic_prices);
        const stockPrices = response.data.historic_prices.map(
          (item) => item.price
        );
        setStockprices(stockPrices);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getInvestmentDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/investment-portfolio/get/${investment_id}/details`
      );

      if (response.status == 200) {
        setRefId(response.data.basic_details.reference_id);
        setstrategyType(response.data.basic_details.strategy_type);
        setRiskProfile(response.data.basic_details.risk_profile);
        setinvestmentType(response.data.basic_details.investment_type);
        setInvestmentManagerNamefromAPI(
          response.data.basic_details.manager.name
        );
        setInvestmentManagerId(response.data.basic_details.manager.id);
        setPreselectedManager({
          label: response.data.basic_details.manager.name,
          value: response.data.basic_details.manager.id,
        });
        setPreselectedManagerAccount({
          label: response.data.basic_details.manager.wallet.account_name,
          value: response.data.basic_details.manager.wallet.id,
        });
        setInvestmentManagerAccount(
          response.data.basic_details.manager.wallet.id
        );
        setInvestmentManagerAccountfromAPI(
          response.data.basic_details.manager.wallet.account_name
        );
        setadvisorIdfromAPI(response.data.basic_details.advisor.name);
        setPreselectedAdvisor({
          label: response.data.basic_details.advisor.name,
          value: response.data.basic_details.advisor.id,
        });
        setPreselectedAdvisorAccount({
          label: response.data.basic_details.advisor.wallet.account_name,
          value: response.data.basic_details.advisor.wallet.id,
        });
        setadvisorAccountfromAPI(
          response.data.basic_details.advisor.wallet.account_name
        );
        setadvisorId(response.data.basic_details.advisor.id);
        setadvisorAccount(response.data.basic_details.advisor.wallet.id);
        setSubadvisorIdfromAPI(response.data.basic_details.sub_advisor.name);
        setPreselectedSubAdvisor({
          label: response.data.basic_details.sub_advisor.name,
          value: response.data.basic_details.sub_advisor.id,
        });
        setPreselectedSubAdvisorAccount({
          label: response.data.basic_details.sub_advisor.wallet.account_name,
          value: response.data.basic_details.sub_advisor.wallet.id,
        });
        setsubAdvisorAccountfromAPI(
          response.data.basic_details.sub_advisor.wallet.account_name
        );
        setSubadvisorId(response.data.basic_details.sub_advisor.id);
        setsubAdvisorAccount(response.data.basic_details.sub_advisor.wallet.id);
        setPlatformIdfromAPI(response.data.basic_details.platform.name);
        setPlatformId(response.data.basic_details.platform.id);
        setplatformAccount(response.data.basic_details.platform.wallet.id);
        setPlatformAccountfromAPI(
          response.data.basic_details.platform.wallet.account_name
        );
        setPreselectedPlatform({
          label: response.data.basic_details.platform.name,
          value: response.data.basic_details.platform.id,
        });
        setPreselectedPlatformAccount({
          label: response.data.basic_details.platform.wallet.account_name,
          value: response.data.basic_details.platform.wallet.id,
        });
        setFundObjectives(
          response.data.basic_details.fund_objective_and_process
        );
        setinvestmentProductName(
          response.data.investment_details.investment_product_name
        );
        setriskRating(response.data.investment_details.risk_rating);
        setGrowth(response.data.investment_details.growth_percentage);
        setDefensive(response.data.investment_details.defensive_percentage);
        setInvestments(response.data.investment_details.tags);
        setmanagerFees(
          response.data.investment_details.investment_manager_fee_percentage
        );
        setadvisorFeesUpdate(
          response.data.investment_details.advisor_fee_percentage
        );
        setmanagerFeesUpdate(
          response.data.investment_details.investment_manager_fee_percentage
        );
        setadvisorFees(response.data.investment_details.advisor_fee_percentage);
        setsubadvisorFees(
          response.data.investment_details.sub_advisor_fee_percentage
        );
        setminimumInvestedAmount(
          response.data.investment_details.minimum_investment
        );
        setstrategyDate(
          formatDate(response.data.investment_details.strategy_creation_date)
        );

        setsmaFees(response.data.investment_details.sma_fee_percentage);
        setsmaFeesUpdate(response.data.investment_details.sma_fee_percentage);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getInvestorDetails = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        `/v1/investment-portfolio/${investment_id}/investors?page=${currentPage}&size=${showRecords}&search=${searchQuery}&status=${filterStatus}`
      );

      if (response.status == 200) {
        setTotalInvestors(response.data.total_unique_investors);
        setTotalInvestedAmount(response.data.total_invested_amount);
        setInvestortableData(response.data.investors);
        settotalPages(response.data.total_pages);
        setCurrentPage(response.data.page);
        settotalCount(response.data.total_count);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const handleSelectInvestmentManagerAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setInvestmentManagerAccount(selectedOption.value);
    setisNewChange(false);
  };
  const handleSelectInvestmentManager = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setInvestmentManagerId(selectedOption.value);
    setPreselectedManagerAccount({});
    setInvestmentManagerAccount(0);
    setisNewChange(false);
  };
  const handleSelectAdvisor = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setadvisorId(selectedOption.value);
    setPreselectedAdvisorAccount({});
    setadvisorAccount(0);
    setisNewChange(false);
  };
  const handleSelectAdvisorAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setadvisorAccount(selectedOption.value);
    setisNewChange(false);
  };
  useEffect(() => {
    getUsers();
  }, []);
  const createInvestor = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment/get/investors-details`;
    const bodyData = {
      client_id: clientId,
      creator_id: creatorId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };

  const formatNumber = (value) => {
    // Format number with commas and two decimal places
    return Number(value).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const unformatNumber = (value) => {
    // Remove commas from the formatted number
    return value.replace(/,/g, "");
  };

  const handleInputChange = (e) => {
    const rawValue = e.target.value; // Raw input value
    const numericValue = unformatNumber(rawValue); // Remove formatting

    if (!isNaN(numericValue)) {
      setInvestmentAmount(numericValue); // Save the unformatted value
    }
    if (numericValue > 0) {
      setportfolioDataAvailable(false);
    }
  };

  const handleBlur = () => {
    if (investmentAmount) {
      setInvestmentAmount(Number(investmentAmount).toFixed(2)); // Ensure two decimal places are retained
    }
  };
  const viewBrekdownAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment/${investment_id}/portfolio-breakdown`;
    const bodyData = {
      amount: Number(investmentAmount),
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const addInvestorDetail = async (e) => {
    e.preventDefault();
    if (clientName == "" || clientId == "" || isClientExist == false) {
      showToast("Please choose the valid client", "error");
      return;
    }
    if (creatorName == "" || creatorId == "" || isCreatorExist == false) {
      showToast("Please choose the valid creator", "error");
      return;
    }
    try {
      const response = await createInvestor();

      if (response.status == 200) {
        setInvestorClientFirstName(response.data.client.first_name);
        setInvestorClientLastName(response.data.client.last_name);
        setInvestorClientEmail(response.data.client.email);
        setInvestorClientPhone(response.data.client.phone);
        setInvestorClientAccountBalance(
          response.data.client.cash_account_balance
        );
        setInvestorClientAbn(response.data.client.abn);
        setIsInvestorAvailable(true);
      } else {
        showToast(response.message, "error");
      }
    } catch (err) {
      showToast(err.message, "error");
    }
  };
  const viewBrekdown = async (e) => {
    e.preventDefault();
    if (investmentAmount == 0) {
      showToast("Please enter the valid amount ", "error");
      return;
    }
    try {
      const response = await viewBrekdownAPI();

      if (response.status == 200) {
        setPortfolioData(response.data.portfolio);
        setportfolioDataAvailable(true);
      } else {
        showToast(response.message, "error");
      }
    } catch (err) {
      showToast(err.message, "error");
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  useEffect(() => {
    getWalletAccountsByManager();
  }, [investmentManagerId]);
  const getWalletAccountsByManager = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/wallet/user/${investmentManagerId}`
      );

      if (response.status == 200) {
        const InvestmentManagerAccountData = [];
        response.data.forEach((profile) => {
          InvestmentManagerAccountData.push({
            value: profile.id,
            label: profile.account_name,
          });
        });
        setInvestmentManagerAccountData(InvestmentManagerAccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setInvestmentManagerAccountData([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getWalletAccountsByPlatform = async () => {
    try {
      const response = await GetAPIcalls(`/v1/wallet/user/${platformId}`);

      if (response.status == 200) {
        const SettlementAccountData = [];
        response.data.forEach((profile) => {
          SettlementAccountData.push({
            value: profile.id,
            label: profile.account_name,
          });
        });
        setSettlementAccountData(SettlementAccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setSettlementAccountData([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    getWalletAccountsByPlatform();
  }, [platformId]);
  const getUsers = async () => {
    try {
      const response = await GetAPIcalls("/v1/user/admin/all-users");

      if (response.status == 200) {
        const users = [];
        response.data.users.forEach((profile) => {
          users.push({
            value: profile.id,
            label: profile.first_name + " " + profile.last_name,
          });
        });
        setUsers(users);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };

  const UpdateInvestment = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment/update/${investment_id}`;
    const bodyData = {
      investment_manager_id: investmentManagerId,
      investment_manager_fee_percentage: Number(managerFeesUpdate),
      investment_manager_wallet_id: InvestmentManagerAccount,
      advisor_id: advisorId,
      advisor_wallet_id: advisorAccount,
      sub_advisor_id: subadvisorId,
      sub_advisor_wallet_id: subAdvisorAccount,
      advisor_fee_percentage: Number(advisorFeesUpdate),
      platform_id: platformId,
      platform_wallet_id: platformAccount,
      sma_fee_percentage: Number(smaFeesUpdate),
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const handleCreateInvestment = async (e) => {
    e.preventDefault();
    if (
      InvestmentManagerAccount == 0 ||
      advisorAccount == 0 ||
      platformAccount == 0
    ) {
      showToast("Please select account", "error");
      return;
    }
    try {
      const response = await UpdateInvestment();

      if (response.status == 200) {
        setisNewChange(true);
        getInvestmentDetails();
        setIsOpen(false);
        togglePopupEdit(false);
        setisNewChangeFees(true);
        setisOpenEdit(false);
      } else {
        showToast(response.message, "error");
      }
    } catch (err) {
      showToast(err.message, "error");
    }
  };
  //Graphs
  const filteredDataGraph = allocationGraphData.filter(
    (item) => item.percentage > 0
  );

  // Prepare labels and allocations for the donut chart
  let labels = filteredDataGraph.map((item) => item.name);
  let allocations = filteredDataGraph.map((item) => item.percentage);

  // Dynamic colors for each slice
  let colors = filteredDataGraph.map((item) => "#" + item.color_code);

  // Donut chart data configuration
  let donutData = {
    labels: labels, // Product names
    datasets: [
      {
        label: "Allocation (%)",
        data: allocations, // Allocation values
        backgroundColor: colors, // Dynamic colors
        borderWidth: 0,
      },
    ],
  };

  // Donut chart options
  const donutOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Disable legend on the donut chart
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            const value = tooltipItem.raw;
            return `${tooltipItem.label}: ${value}%`;
          },
        },
      },
    },
    cutout: "65%", // Creates the hole in the center for the donut chart
  };

  return (
    <div className="">
      <div className="">
        <div className="pt-6 pr-4 flex-wrap items-center">
          <div className="flex mb-2">
            <button
              onClick={() => setFilter("details")}
              className={`px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
                filter === "details"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              Details
            </button>
            <button
              onClick={() => setFilter("investors")}
              className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
                filter === "investors"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              Investors
            </button>
            <button
              onClick={() => setFilter("view")}
              className={`px-4 py-2 rounded-r-xl ${
                filter === "view"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              View
            </button>
          </div>
        </div>
        {filter == "view" && (
          <div className="w-full  p-4 bg-white rounded-lg shadow-lg">
            <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
              <h1 className="text-lg font-medium mb-2">
                Fact Sheet:
                <span className="text-[#888888]">
                  {" "}
                  Caprock Model Portfolio - Alternative Growth
                </span>
              </h1>
            </div>
            <div className="overflow-x-auto border-b mb-4">
              <table className="w-full h-full border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2 ">
                {/* Table Header */}
                <thead className="text-[#8C8C8C]  rounded-md mb-2 text-sm">
                  <tr className="border border-[#EDEDED]">
                    {secondheaders.map((header, index) => (
                      <th
                        key={header}
                        className={`
                            cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-left
                            ${
                              index === 0
                                ? "border-t rounded-tl-md rounded-bl-md border-b border-l border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                                ${
                                  index === 1 || index === 2 || index === 3
                                    ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                    : ""
                                }
                              ${
                                index === 4
                                  ? "border-t border-b rounded-tr-md rounded-br-md border-r  border-[#EDEDED]" // Center column: Top and Bottom border only
                                  : ""
                              }
                          `}
                      >
                        <div class="flex items-center">
                          <span>{header}</span>
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>

                {/* Table Body */}
                <tbody className="text-sm mt-6  font-medium text-black">
                  <tr className="mb-2 bg-[#F9F9F9]">
                    <td className="px-4 py-4 w-1/2 text-ellipsis  overflow-hidden whitespace-nowrap">
                      {investmentManagerNameView}
                    </td>

                    {/* Dropdown Button */}
                    <td className="px-4 py-4 relative">{dateCreated}</td>

                    <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                      {strategyTypeView}
                    </td>

                    <td className="px-4 py-4 text-left text-ellipsis  overflow-hidden whitespace-nowrap">
                      {growth}
                    </td>

                    <td className="px-4 py-4 text-left">{defensive}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="mt-6 mb-4 px-4">
              <label
                htmlFor="fundObjective"
                className="block mb-1 text-md font-semibold text-black"
              >
                Fund Objective & Process
              </label>
              <div
                dangerouslySetInnerHTML={{ __html: fundObjectives }}
                className="text-sm"
              ></div>
            </div>
          </div>
        )}
        {filter == "view" && (
          <div className="w-full  p-4 mt-6 bg-white rounded-lg shadow-lg">
            <div className="mt-2">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="refId"
                    className="mb-1 text-sm text-[#A6A6A6]"
                  >
                    Code
                  </label>
                  <span>{refId}</span>
                  <div className="mt-4">
                    <label
                      htmlFor="investmentType"
                      className="mb-1 text-sm text-[#A6A6A6]"
                    >
                      Investment Product Name
                    </label>
                    <div>{investmentProductName}</div>
                  </div>
                  <div className="mt-4">
                    <label
                      htmlFor="investmentType"
                      className="mb-1  text-sm text-[#A6A6A6]"
                    >
                      Risk Rating
                    </label>
                    <div>{riskRating}</div>
                  </div>
                  <div className="mt-4">
                    <label
                      htmlFor="investmentType"
                      className="mb-1  text-sm text-[#A6A6A6]"
                    >
                      Advisor Fees %
                    </label>
                    <div>{advisorFees}</div>
                  </div>
                </div>
                {/* center column */}
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <div className="grid grid-cols-2 gap-4">
                    {/* Growth (%) */}
                    <div>
                      <label className="block text-sm text-[#A6A6A6]">
                        Growth (%)
                      </label>
                      <div className="relative">{growth}</div>
                    </div>

                    {/* Defensive (%) */}
                    <div>
                      <label className="block text-sm text-[#A6A6A6]">
                        Defensive (%)
                      </label>
                      <div className="relative">{defensive}</div>
                    </div>
                  </div>

                  {/* Investments */}
                  <div>
                    <label className="block mb-1 mt-4 text-sm text-[#A6A6A6]">
                      Investments
                    </label>
                    <div className="mt-1   flex flex-wrap gap-2">
                      {investments.map((investment, index) => (
                        <div
                          key={index}
                          className="flex items-center bg-[#FCFCFC] text-gray-700 text-sm px-3 py-1 rounded-lg border shadow-sm"
                        >
                          <span>{investment}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="mt-4">
                    <label
                      htmlFor="investmentType"
                      className="mb-1  text-sm text-[#A6A6A6]"
                    >
                      SMA Fees % | Including GST
                    </label>
                    <div>{smaFees}</div>
                  </div>
                </div>
                {/* Left column */}
                <div className="flex lg:pt-4 pt-0 flex-col px-4">
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 text-sm"
                  >
                    <span className="text-[#A6A6A6]">
                      Investment Manager Fees % | Weighted Average
                    </span>
                  </label>
                  <div>{managerFees}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Sub Advisor Fees %</span>
                  </label>
                  <div>{subadvisorFees}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">
                      Strategy Inception Date
                    </span>
                  </label>
                  <div>{strategyDate}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 text-sm"
                  >
                    <span className="text-[#A6A6A6]">
                      Minimum Investment Amount
                    </span>
                  </label>
                  <div>{minimumInvestedAmount}</div>
                </div>
              </div>
            </div>
          </div>
        )}
        {filter == "view" && (
          <div className="bg-white mt-6 p-6 px-8 shadow-md rounded-md">
            {/* Header */}
            <h2 className="text-lg font-semibold font-semibold mb-4">
              Current Target Allocation
            </h2>

            {/* Table Header */}
            <div className="overflow-x-auto ml-4 mb-4">
              <table className=" w-full table-auto border-collapse">
                <thead>
                  <tr className="pl-14">
                    <th className="py-2 px-6 text-sm font-medium text-[#8C8C8C] border-b">
                      No
                    </th>
                    <th className="py-2 px-4 text-sm w-30 font-medium text-[#8C8C8C] border-b">
                      Security (Code)
                    </th>
                    <th className="py-2 px-2 text-sm w-60 font-medium text-[#8C8C8C] border-b">
                      Name
                    </th>
                    <th className="py-2 pl-10  text-sm font-medium text-[#8C8C8C] border-b">
                      Allocation (%)
                    </th>
                    <th className="py-2 px-4 text-sm font-medium text-[#8C8C8C] border-b">
                      Market Price (AUD)
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            {newCategories.map((category, categoryIndex) => (
              <div key={category.category.name} className="mb-6">
                <div
                  className={`flex items-center flex-wrap justify-between p-4  rounded-md ${
                    category.category.name === "Defensive"
                      ? "bg-[#A9D4AB]"
                      : "bg-[#92C5EA]"
                  }`}
                >
                  <div className="flex items-center flex-grow cursor-pointer">
                    <span className="text-sm md:text-lg font-bold text-black">
                      {category.category.name}
                    </span>
                  </div>
                </div>

                {/* Subcategories */}
                <div
                  className={`ml-4 md:ml-6 border-l-2 ${
                    category.category.name === "Defensive"
                      ? "border-[#A9D4AB]"
                      : "border-[#92C5EA]"
                  }`}
                >
                  {category.category.products.map(
                    (subcategory, subcategoryIndex) => (
                      <div
                        key={subcategory.name}
                        className="relative mb-2 pt-2 text-left"
                      >
                        {/* Subcategory Header */}
                        <div className="flex items-center justify-start  rounded-md cursor-pointer">
                          {category.category.name === "Defensive" ? (
                            <img
                              src="/green-arrow.svg"
                              alt="Arrow"
                              className="w-5 h-5"
                            />
                          ) : (
                            <img
                              src="/arrow-hierarchy.svg"
                              alt="Arrow"
                              className="w-5 h-5"
                            />
                          )}

                          <div
                            className={`flex items-center justify-start p-4 w-full  rounded-md cursor-pointer ${
                              category.category.name === "Defensive"
                                ? "bg-[#C0E2C1]"
                                : "bg-[#C6DFF1] "
                            }`}
                          >
                            <div
                              key={category.category.name}
                              className="flex items-center justify-between w-full space-x-6"
                            >
                              <div className="text-sm md:text-md w-1/3 mr-[1.5rem] font-bold text-black">
                                {`${subcategoryIndex + 1}. ${subcategory.name}`}
                              </div>

                              <div className="text-sm md:text-md  w-50 font-bold text-black">
                                <div className="relative">
                                  <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    max="100"
                                    disabled={true}
                                    value={subcategory.allocation.toFixed(2)}
                                    className="lg:w-30 w-30 text-sm bg-white px-3 py-3 rounded-xl text-black bg-white border shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black"
                                  />
                                  <span className="absolute inset-y-0 right-3 flex items-center text-sm font-medium text-[#8C8C8C]">
                                    %
                                  </span>
                                </div>
                              </div>
                              <div className="text-sm md:text-md font-bold text-black"></div>
                            </div>
                            {/* <span className="text-sm md:text-lg w-60 mr-7 font-semibold text-black">
                              {`${subcategoryIndex + 1}. ${subcategory.name}`}
                            </span>

                            <div className="relative w-20 mr-0 md:ml-80  lg:ml-80 ">
                              <input
                                type="number"
                                step="0.01"
                                min="0"
                                max="100"
                                disabled={true}
                                value={subcategory.allocation.toFixed(2)}
                                className="lg:w-20 w-20 text-sm bg-white px-3 py-3 rounded-xl text-black bg-white border shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black"
                              />
                              <span className="absolute inset-y-0 right-3 flex items-center text-sm font-medium text-[#8C8C8C]">
                                %
                              </span>
                            </div> */}
                          </div>
                        </div>
                        {/* Table of Items */}
                        <div className="ml-6 pl-0" style={{ height: "50%" }}>
                          <div className="relative overflow-x-auto">
                            <table className="min-w-full h-full table-fixed ">
                              <tbody className="rounded-md">
                                {subcategory.stocks.map(
                                  (item, itemIndex, filteredStocks) => (
                                    <tr
                                      key={itemIndex}
                                      className="text-left w-full mt-3  rounded-xl"
                                    >
                                      {itemIndex >= 0 && (
                                        <td
                                          className={`w-3 px-1 md:px-0 lg:px-1 relative
                                ${
                                  itemIndex === subcategory.stocks.length - 1
                                    ? ""
                                    : ""
                                }`}
                                        >
                                          {itemIndex ===
                                          subcategory.stocks.length - 1 ? (
                                            <div
                                              className={`absolute left-0 top-0  w-[2px]  ${
                                                category.name === "Defensive"
                                                  ? "bg-[#C0E2C1]"
                                                  : "bg-[#C6DFF1]"
                                              }`}
                                              style={{
                                                height: "60%", // 60% of the parent height
                                              }}
                                            ></div>
                                          ) : (
                                            <div
                                              className={`absolute left-0 top-0 h-full w-[2px] ${
                                                category.category.name ===
                                                "Defensive"
                                                  ? "bg-[#C0E2C1]"
                                                  : "bg-[#C6DFF1]"
                                              }`}
                                            ></div>
                                          )}
                                          {category.category.name ===
                                          "Defensive" ? (
                                            <img
                                              src="/green-arrow.svg"
                                              alt="Arrow"
                                              className="absolute left-0 w-3 h-3 mx-auto"
                                            />
                                          ) : (
                                            <img
                                              src="/arrow-hierarchy.svg"
                                              alt="Arrow"
                                              className="absolute left-0 w-3 h-3 mx-auto"
                                            />
                                          )}
                                        </td>
                                      )}
                                      <td
                                        className={`py-2 h-full w-10 py-2 border-t-4 border-white rounded-l-lg mt-2 px-2 ${
                                          category.category.name === "Defensive"
                                            ? "bg-[#E7F5E8]"
                                            : "bg-[#E6F3FC]"
                                        }`}
                                      >
                                        {`${String.fromCharCode(
                                          97 + itemIndex
                                        )}`}
                                        . {/* Item Number (a, b, c) */}
                                      </td>
                                      <td
                                        className={`pt-2 w-20 border-t-4 border-white py-2 px-4 ${
                                          category.category.name === "Defensive"
                                            ? "bg-[#E7F5E8]"
                                            : "bg-[#E6F3FC]"
                                        }`}
                                      >
                                        <div className="">
                                          <button className="flex rounded-xl justify-between  w-20 px-2 py-2 text-left text-sm font-medium bg-white border rounded-md shadow-sm hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-black">
                                            {item.asx_code}
                                          </button>
                                        </div>
                                      </td>
                                      <td
                                        className={`py-2 border-t-4 border-white px-4 w-2/3 ${
                                          category.category.name === "Defensive"
                                            ? "bg-[#E7F5E8]"
                                            : "bg-[#E6F3FC]"
                                        }`}
                                      >
                                        <span className="block md:break-words text-ellipsis  overflow-hidden whitespace-nowrap break-normal md:truncate lg:whitespace-normal w-full">
                                          {item.name}
                                        </span>
                                      </td>
                                      <td
                                        className={`py-2 border-t-4 border-white relative w-50 px-4 ${
                                          category.category.name === "Defensive"
                                            ? "bg-[#E7F5E8]"
                                            : "bg-[#E6F3FC]"
                                        }`}
                                      >
                                        <div className="relative">
                                          <input
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            max="100"
                                            disabled={true}
                                            value={item.allocation.toFixed(2)}
                                            className="lg:w-20 w-20 text-sm bg-white px-3 py-3 rounded-xl text-black bg-white border shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black"
                                          />
                                          <span className="absolute inset-y-0 right-3 flex items-center text-sm font-medium text-[#8C8C8C]">
                                            %
                                          </span>
                                        </div>
                                      </td>
                                      <td
                                        className={`py-4 border-t-4 border-white rounded-r-lg px-4 w-full font-semibold text-md text-black ${
                                          category.category.name === "Defensive"
                                            ? "bg-[#E7F5E8]"
                                            : "bg-[#E6F3FC]"
                                        }`}
                                      >
                                        <span className="ml-10">
                                          {item.market_price.toFixed(2)}
                                        </span>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
                <div
                  className={`flex items-center p-4 mt-4 border rounded-md ${
                    category.category.name === "Defensive"
                      ? "border-[#A9D4AB]"
                      : "border-[#92C5EA]"
                  }`}
                >
                  <div
                    key={category.category.name}
                    className="flex items-center justify-between w-full space-x-4"
                  >
                    <div className="text-sm md:text-md font-bold text-black">
                      SUB-TOTAL {category.category.name}
                    </div>
                    <div className="text-sm md:text-md font-bold text-black"></div>

                    <div className="text-sm md:text-md font-bold text-black">
                      {category.category.allocation.toFixed(2)} %
                    </div>
                    <div className="text-sm md:text-md font-bold text-black"></div>
                  </div>
                </div>
              </div>
            ))}
            <div className="flex items-center p-4 border rounded-md border-black">
              <div className="flex items-center justify-between w-full space-x-4">
                <div className="text-sm md:text-md font-bold text-black">
                  TOTAL PORTFOLIO
                </div>
                <div className="text-sm md:text-md font-bold text-black"></div>

                <div className="text-sm md:text-md font-bold text-black">
                  100%
                </div>
                <div className="text-sm md:text-md font-bold text-black"></div>
              </div>
            </div>
          </div>
        )}
        {filter == "view" && (
          <div className="bg-white mt-6 p-6 px-8 shadow-md rounded-md">
            {/* Header */}
            <h2 className="text-lg font-semibold font-semibold mb-4">
              Caprock Funds Management {riskProfile}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              <div className="space-y-4">
                <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-3 gap-4 text-sm">
                  {allocationGraphData.map((item, index) => (
                    <div
                      key={item.name}
                      className="flex flex-col items-start break-words whitespace-normal"
                    >
                      {/* Product Name */}
                      <span className="font-medium text-sm text-[#A6A6A6] w-full break-words">
                        {item.name}
                      </span>

                      {/* Allocation Percentage */}
                      <span
                        className="text-md font-medium mt-1 break-words"
                        style={{ color: `#${item.color_code}` }}
                      >
                        {item.percentage}%
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Donut Chart */}
              <div className="flex justify-end">
                <div className="w-full md:w-2/3 lg:w-1/2">
                  <Doughnut data={donutData} options={donutOptions} />
                </div>
              </div>
            </div>
            <div className="py-6 px-4 bg-white">
              <div className="mb-4 flex flex-wrap justify-between items-center">
                <span>
                  <h3 className="text-lg font-semibold text-gray-800 w-full md:w-auto">
                    Historical Performance
                  </h3>

                  <p className="text-sm font-normal text-[#868686] w-full md:w-auto">
                    Caprock {riskProfile}
                  </p>
                </span>{" "}
              </div>
              <div className="mb-4  flex">
                {["5Y", "1Y", "3M", "1M"].map((filter, index) => (
                  <button
                    key={filter}
                    className={`px-3 py-1 shadow-md ${
                      filter === "1M" ? "rounded-r-xl" : ""
                    }
            ${filter === "5Y" ? "rounded-l-xl" : ""}
             
               ${
                 selectedFilter === filter
                   ? "bg-black text-white"
                   : "bg-white text-black"
               }`}
                    onClick={() => setSelectedFilter(filter)}
                  >
                    {filter}
                  </button>
                ))}
              </div>

              <div style={{ width: "100%", height: "400px" }}>
                <Line data={dataLine} options={optionsLine} />
              </div>
            </div>
          </div>
        )}
        {filter == "view" && (
          <div className="w-full p-6  mt-6 bg-white px-8  rounded-md shadow-sm">
            <div className="space-y-4 pt-4">
              {/* Historical Performance Note */}
              <div>
                <label
                  htmlFor="historical-performance"
                  className="block text-sm font-medium text-[#A6A6A6]"
                >
                  Past Performance
                </label>
                <div className="w-full mt-2 p-3 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                  {pastPerformance}
                </div>
              </div>

              {/* Disclaimer */}
              <div>
                <label
                  htmlFor="disclaimer"
                  className="block text-sm font-medium text-[#A6A6A6]"
                >
                  Disclaimer
                </label>
                <div className="w-full text-sm mt-2 p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                  {disclaimer}
                </div>
              </div>

              {/* Copyright */}
              <div>
                <label
                  htmlFor="copyright"
                  className="block text-sm font-medium text-[#A6A6A6]"
                >
                  Copyright
                </label>
                <div className="w-full mt-2 text-sm p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                  {copyright}{" "}
                </div>
              </div>
            </div>
          </div>
        )}
        {filter == "investors" && (
          <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
            {/* Top Navigation */}
            <div className="bg-white p-6 shadow rounded-lg ">
              <div className="flex items-center space-x-4 mb-6">
                <span
                  onClick={() => setIsCurrentInvestorSelected(true)}
                  className={`cursor-pointer   pr-4 font-medium ${
                    isCurrentInvestorSelected
                      ? "border-black text-black border-b-2"
                      : "text-gray-500"
                  }`}
                >
                  Current Investors
                </span>
                <span className="text-[#B2B2B2]">|</span>
                <span
                  className={`cursor-pointer  font-medium ${
                    !isCurrentInvestorSelected
                      ? "border-black text-black border-b-2"
                      : "text-gray-500"
                  }`}
                  onClick={() => setIsCurrentInvestorSelected(false)}
                >
                  Add Investor
                </span>{" "}
              </div>
              {isCurrentInvestorSelected && (
                <div className="p-2 mb-4">
                  <div className="flex flex-col border-b pb-3 md:flex-row md:justify-between md:items-center">
                    {/* Left-aligned Heading */}
                    <h3 className="text-lg font-medium mb-2 md:text-ellipsis  md:overflow-hidden md:whitespace-nowrap md:mb-0">
                      Caprock Model Portfolio - Alternative Growth
                    </h3>

                    {/* Right-aligned Information */}
                    <div className="flex flex-wrap items-center space-x-2">
                      <div className="flex flex-col items-center">
                        <span className="text-sm font-semibold text-[#464646] leading-tight">
                          Number of
                        </span>
                        <span className="text-sm font-semibold text-[#464646] leading-tight">
                          Investors
                        </span>
                      </div>{" "}
                      <span className="text-md font-semibold">|</span>
                      <span className="text-sm font-semibold rounded-md text-white py-1 px-3 bg-[#3047EC]">
                        {totalInvestors}
                      </span>
                      <span className="text-md font-semibold">|</span>
                      <div className="flex flex-col items-center">
                        <span className="text-sm font-semibold text-[#464646] leading-tight">
                          Total
                        </span>
                        <span className="text-sm font-semibold text-[#464646] leading-tight">
                          Invested $
                        </span>
                      </div>{" "}
                      <span className="text-sm font-semibold">|</span>
                      <span className="text-sm font-semibold rounded-md text-white py-1 px-3 bg-[#3047EC]">
                        ${totalInvestedAmount}
                      </span>
                    </div>
                  </div>
                  <div className="flex justify-between mt-4 flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                    <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                      <div className="flex items-center space-x-2">
                        <span className="lg:text-md  text-sm text-[#8C8C8C]">
                          Show Records
                        </span>
                        <Dropdown
                          label=""
                          options={filterOptions}
                          preselectedValue={preSelectedFilter}
                          onSelect={handleFilterChange}
                        />
                      </div>
                      <div className="flex items-center">
                        <div className="relative">
                          <input
                            type="text"
                            className="p-2 pl-8 border rounded-xl"
                            placeholder="Search Portfolios"
                            value={searchQuery}
                            onChange={(e) => {
                              setCurrentPage(1);
                              setSearchQuery(e.target.value);
                            }}
                          />
                          <span className="absolute left-2 top-3 text-gray-500">
                            {" "}
                            <img
                              src="/search-normal.png"
                              alt="Company Logo"
                              className="mr-2"
                            />
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-col md:flex-row items-center space-x-0 md:space-x-4">
                      <div className="relative w-full md:w-full">
                        {/* Dropdown Button */}
                        <button
                          onClick={() => setIsOpenFilter(!isOpenFilter)}
                          className={`w-60 md:w-full border font-medium border-gray-300 h-10 rounded-xl text-sm px-2 py-2 pr-10 flex justify-between items-center focus:outline-none ${
                            isOpenFilter
                              ? "bg-black text-white"
                              : "bg-white text-black"
                          }`}
                        >
                          <div className="flex items-center">
                            {isOpenFilter ? (
                              <img
                                src="/filter-sort-white.svg"
                                alt="Filter Icon"
                                className="h-5 w-5 mr-2"
                              />
                            ) : (
                              <img
                                src="/filter-sort-black.svg"
                                alt="Filter Icon"
                                className="h-5 w-5 mr-2"
                              />
                            )}
                            Filter Status
                          </div>
                        </button>

                        {/* Dropdown List */}
                        {isOpenFilter && (
                          <div
                            className="absolute left-0 mt-2 overflow-y-auto mb-5 w-full bg-white border rounded-md shadow-lg z-50"
                            style={{
                              maxHeight: "200px", // Optional: limit height
                            }}
                          >
                            {allFilteraStatus.map((option) => (
                              <div
                                onClick={() => {
                                  setFilterStatus(option.value);
                                  setIsOpenFilter(false);
                                }}
                                key={option.value}
                                className="px-4 py-2 flex items-center hover:bg-black hover:text-white cursor-pointer"
                              >
                                {option.label}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      <div className="relative mt-2 w-full  md:mt-0 inline-block ">
                        <div
                          className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                          onClick={() => setisOpenDownload(!isOpenDownload)}
                        >
                          <img
                            src="/document-download.png"
                            alt="document-download"
                            className="mr-2"
                          />
                          <span>{selected}</span>
                          <span className="text-gray-500">
                            {" "}
                            <img
                              src="/download-small-arrow.svg"
                              alt="document-download"
                              className=""
                            />
                          </span>
                        </div>
                        {isOpenDownload && (
                          <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                            {options.map((option) => (
                              <li
                                key={option.value}
                                className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                                onClick={() => handleSelect(option)}
                              >
                                {option.label}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="overflow-x-auto ">
                    <table className="w-full h-full  border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2">
                      {/* Table Header */}
                      <thead className="text-[#8C8C8C] text-sm">
                        <tr className="border border-[#EDEDED]">
                          {investorheaders.map((header, index) => (
                            <th
                              key={header}
                              className={`
                            cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-left
                            ${
                              index === 0
                                ? "border-t border-b border-l rounded-tl-md rounded-bl-md border-r-0 border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                                ${
                                  index === 1 || index === 2
                                    ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                    : ""
                                }
                              ${
                                index === 3
                                  ? "border-t border-b border-r rounded-tr-md rounded-br-md  border-[#EDEDED]" // Center column: Top and Bottom border only
                                  : ""
                              }
                          `}
                            >
                              <span>{header}</span>
                            </th>
                          ))}
                        </tr>
                      </thead>

                      {isLoading ? (
                        <tbody className="shimmer-container-list ">
                          {/* Creating 5 rows of shimmer effect */}
                          {[...Array(5)].map((_, rowIndex) => (
                            <tr key={rowIndex} className="shimmer-row-list">
                              {/* Creating 7 cells in each row for shimmer */}
                              {[...Array(4)].map((_, colIndex) => (
                                <td
                                  key={colIndex}
                                  className="shimmer-cell-list"
                                >
                                  <div className="shimmer-loader"></div>
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody className="text-sm font-medium text-black">
                          {investortableData.map((row) => (
                            <tr className="mb-2 bg-[#F9F9F9]">
                              {/* Dropdown Button */}
                              <td className="px-4 py-4 relative">
                                {formatDateList(row.request_date)}
                              </td>

                              <td className="px-4 py-4 text-ellipsis  cursor-pointer overflow-hidden whitespace-nowrap">
                                {row.investor_name}
                              </td>

                              <td className="px-4 py-4 text-left text-ellipsis  overflow-hidden whitespace-nowrap">
                                $
                                {row.invested_amount

                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </td>

                              <td className="px-4 py-4 text-left">
                                $
                                {row.cash_account
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </table>
                  </div>
                  {!isLoading && (
                    <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                      {/* Entries Info Section */}
                      <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                        Showing {showRecords * (currentPage - 1) + 1} to{" "}
                        {currentPage === totalPages || totalPages == 0
                          ? totalCount
                          : Math.max(
                              showRecords * currentPage,
                              investortableData.length
                            )}{" "}
                        of {totalCount} entries
                      </div>

                      {/* Pagination Section */}
                      <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                        {/* Previous Button */}
                        <button
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage((prev) => prev - 1)}
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Prev
                        </button>

                        {/* Page Buttons */}
                        {Array.from({ length: Math.min(totalPages, 5) }).map(
                          (_, index) => {
                            const startPage = Math.max(
                              1,
                              Math.min(totalPages - 4, currentPage - 2)
                            );
                            const page = startPage + index;

                            return (
                              <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                className={`px-3 py-1 rounded ${
                                  currentPage === page
                                    ? "bg-black text-white"
                                    : "bg-white border border-gray-300 text-black"
                                }`}
                              >
                                {page}
                              </button>
                            );
                          }
                        )}

                        {/* Next Button */}
                        <button
                          disabled={currentPage === totalPages}
                          onClick={() => setCurrentPage((prev) => prev + 1)}
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/* Input Section */}
              {!isCurrentInvestorSelected && (
                <div className=" mb-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    <div className="flex  flex-col pr-4 pt-4">
                      <label
                        htmlFor="refId"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Client Id
                      </label>
                      <input
                        id="refId"
                        type="text"
                        value={clientId}
                        onBlur={handleBlurClientId}
                        onChange={(e) => setClientId(e.target.value)}
                        className={`border p-2 text-black font-medium rounded-md text-md ${
                          isClientExist || clientName == ""
                            ? "border-black"
                            : "border-[#FF5050]"
                        }`}
                        placeholder="C947534324"
                      />
                      <div className="flex bg-[#F9F9F9] rounded-md px-2 py-2 items-center mt-2 space-x-2">
                        <span className="text-sm text-labelColour font-medium">
                          Client Name:{" "}
                        </span>
                        {isClientExist && clientName && (
                          <img
                            src="/valid.svg" // Replace with your icon path
                            alt="User Icon"
                            className="w-4 h-4"
                          />
                        )}
                        {!isClientExist && clientName && (
                          <img
                            src="/danger.svg" // Replace with your icon path
                            alt="User Icon"
                            className="w-4 h-4"
                          />
                        )}
                        <span
                          className={`text-sm font-medium ${
                            isClientExist
                              ? "text-black text-sm"
                              : "text-[#FF5050] text-xs"
                          }`}
                        >
                          {clientName}
                        </span>
                      </div>
                    </div>
                    {/* center column */}
                    <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l  border-gray-300 pr-4 md:pl-4">
                      <label
                        htmlFor="refId"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Creator Id
                      </label>
                      <input
                        id="refId"
                        type="text"
                        value={creatorId}
                        onBlur={handleBlurCreatorId}
                        onChange={(e) => setCreatorId(e.target.value)}
                        className={`border p-2 text-black font-medium rounded-md text-md ${
                          isCreatorExist || creatorName == ""
                            ? "border-black"
                            : "border-[#FF5050]"
                        }`}
                        placeholder="C947534324"
                      />
                      <div className="flex bg-[#F9F9F9] rounded-md px-2 py-2 items-center mt-2 space-x-2">
                        <span className="text-sm text-labelColour font-medium">
                          Creator Name:{" "}
                        </span>
                        {isCreatorExist && creatorName && (
                          <img
                            src="/valid.svg" // Replace with your icon path
                            alt="User Icon"
                            className="w-4 h-4"
                          />
                        )}
                        {!isCreatorExist && creatorName && (
                          <img
                            src="/danger.svg" // Replace with your icon path
                            alt="User Icon"
                            className="w-4 h-4"
                          />
                        )}
                        <span
                          className={` text-ellipsis  overflow-hidden whitespace-nowrap font-medium ${
                            isCreatorExist
                              ? "text-black text-sm"
                              : "text-[#FF5050] text-xs"
                          }`}
                        >
                          {creatorName}
                        </span>
                      </div>
                    </div>
                    {/* Left column */}
                    <div className="flex lg:pt-4 pt-0 flex-col px-4"></div>
                  </div>

                  {/* Add Investor Button */}
                  <button
                    disabled={isClientExist && isCreatorExist ? false : true}
                    onClick={addInvestorDetail}
                    className={`mt-6 px-4 py-2 rounded-full ${
                      isClientExist && isCreatorExist
                        ? "bg-black text-white"
                        : "bg-gray-300 text-gray-600"
                    }`}
                  >
                    Add Investor
                  </button>
                </div>
              )}
            </div>
            {/* Investor Details */}
            {!isCurrentInvestorSelected && isInvestorAvailable && (
              <div className="bg-white p-6 mt-4 rounded-lg shadow ">
                <h3 className="text-md font-semibold mb-4 pb-2 border-b">
                  Investor Details
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                  <div className="flex flex-col px-4 pt-4">
                    <div>
                      <span className="block text-[#A6A6A6] text-sm">
                        First Name
                      </span>
                      <span className="font-medium">
                        {investorClientFirstName}
                      </span>
                    </div>
                    <div>
                      <span className="block  mt-4 text-[#A6A6A6] text-sm">
                        Last Name
                      </span>
                      <span className="font-medium">
                        {investorClientLastName}
                      </span>
                    </div>
                  </div>
                  {/* center column */}
                  <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                    <div>
                      <span className="block text-[#A6A6A6] text-sm">
                        Email
                      </span>
                      <span className="font-medium">{investorClientEmail}</span>
                    </div>
                    <div>
                      <span className="block mt-4 text-[#A6A6A6] text-sm">
                        Mobile Number
                      </span>
                      <span className="font-medium">{investorClientPhone}</span>
                    </div>
                  </div>
                  {/* Left column */}
                  <div className="flex lg:pt-4 pt-0 flex-col px-4">
                    <div>
                      <span className="block  text-[#A6A6A6] text-sm">
                        Cash Account Balance
                      </span>
                      <span className="font-medium">
                        ${" "}
                        {investorClientAccountBalance
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </span>
                    </div>
                    <div>
                      <span className="block mt-4 text-[#A6A6A6] text-sm">
                        ABN
                      </span>
                      <span className="font-medium">{investorClientAbn}</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Portfolio Breakdown */}
            {!isCurrentInvestorSelected && (
              <div className="bg-white p-6 rounded-lg shadow mt-4">
                <div className="flex justify-between items-center border-b mb-4">
                  <h3 className="text-md font-semibold mb-2 ">
                    Portfolio Breakdown
                  </h3>
                </div>

                {/* Investment Amount */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0 mb-4">
                  {/* Left Section: Input Field and Button */}
                  <div className="flex flex-col w-full md:w-1/3 lg:w-1/4">
                    {/* Label */}
                    <label
                      htmlFor="investmentAmount"
                      className="text-sm font-medium text-labelColour mb-2"
                    >
                      Investment Amount
                    </label>

                    {/* Input and Button Section */}
                    <div className="flex items-center space-x-2">
                      {/* Input Field */}
                      <div className="relative flex-grow">
                        {/* Dollar Icon */}
                        <span className="absolute inset-y-0 left-2 flex items-center text-gray-500">
                          $
                        </span>
                        <input
                          id="investmentAmount"
                          type="text"
                          value={
                            investmentAmount
                              ? formatNumber(investmentAmount)
                              : ""
                          }
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                          className="pl-6 pr-3 py-2 border border-gray-300 rounded-md text-right w-full md:w-40"
                        />
                      </div>

                      {/* View Breakdown Button */}
                      <button
                        disabled={portfolioDataAvailable ? true : false}
                        onClick={viewBrekdown}
                        className="bg-black text-white px-4 py-2 text-sm rounded-full whitespace-nowrap"
                      >
                        View Breakdown
                      </button>
                    </div>
                  </div>

                  {/* Right Section: Download Report */}
                  <div className="flex items-center justify-end w-60 md:w-1/3 lg:w-1/4">
                    <div className="relative mt-6">
                      {/* Dropdown Button */}
                      <div
                        className="flex justify-between w-60 items-center px-3 py-2 border border-gray-300 rounded-md cursor-pointer"
                        onClick={() =>
                          setisOpenInvestorDropdown(!isOpenInvestorDropdown)
                        }
                      >
                        <img
                          src="/document-download.png"
                          alt="Download Icon"
                          className="w-4 h-4 mr-2"
                        />
                        <span className="flex-grow truncate">
                          {selectedInvestorReport}
                        </span>
                        <img
                          src="/download-small-arrow.svg"
                          alt="Chevron Down"
                          className="w-3 h-3 text-gray-500"
                        />
                      </div>

                      {/* Dropdown Options */}
                      {isOpenInvestorDropdown && (
                        <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                          {options.map((option) => (
                            <li
                              key={option.value}
                              className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                              onClick={() => handleSelectInvestorReport(option)}
                            >
                              {option.label}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>

                {/* Table */}
                {portfolioDataAvailable && (
                  <div className="overflow-x-auto">
                    <table className="table-auto border-collapse w-full text-sm">
                      <thead>
                        <tr className="bg-[#6AA7D3] text-white font-semibold">
                          <th className="border border-white  px-4 py-2">No</th>
                          <th className="border border-white  px-4 py-2">
                            Strategic Asset Allocation
                          </th>
                          <th className="border border-white  px-4 py-2">
                            Code
                          </th>
                          <th className="border border-white  px-4 py-2">
                            SAA
                          </th>
                          <th className="border border-white  px-4 py-2">
                            Capital
                          </th>
                          <th className="border bg-[#F4D580]  border-white  px-4 py-2">
                            Market Price
                          </th>
                          <th className="border border-white  px-4 py-2">
                            Shares
                          </th>
                          <th className="border border-white  px-4 py-2">
                            Value ($)
                          </th>
                          <th className="border border-white  px-4 py-2">
                            Brokerage
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {portfolioData.map((categoryData, categoryIndex) => (
                          <React.Fragment key={categoryIndex}>
                            {/* Category Row */}
                            <tr
                              className={`px-6 py-2 rounded-lg ${
                                categoryData.category.name.toUpperCase() ==
                                "GROWTH"
                                  ? "bg-[#92C5EA]"
                                  : "bg-[#A9D4AB]"
                              }`}
                            >
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              >
                                {categoryData.category.name.toUpperCase()}
                              </td>
                              <td
                                colSpan={1}
                                className="border border-white  px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white bg-[#F4D580]  px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className={`border border-white px-4 py-2 font-bold ${
                                  categoryData.category.name.toUpperCase() ==
                                  "GROWTH"
                                    ? ""
                                    : "bg-[#F8C5C5]"
                                }`}
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                            </tr>

                            {/* Products */}
                            {categoryData.category.products.map(
                              (product, productIndex) => (
                                <React.Fragment key={productIndex}>
                                  {/* Product Row */}
                                  <tr
                                    className={`text-[#005A9C] ${
                                      categoryData.category.name.toUpperCase() ==
                                      "GROWTH"
                                        ? "bg-[#C6DFF1]"
                                        : "bg-[#C0E2C1]"
                                    }`}
                                  >
                                    <td
                                      colSpan={1}
                                      className="border border-white px-4 py-2 font-bold"
                                    >
                                      {(productIndex + 1)
                                        .toString()
                                        .padStart(2, "0")}
                                    </td>
                                    <td
                                      colSpan={1}
                                      className="border border-white px-4 py-2 font-semibold"
                                    >
                                      {product.name}
                                    </td>
                                    <td
                                      colSpan={1}
                                      className="border border-white px-4 py-2 font-semibold"
                                    ></td>
                                    <td
                                      colSpan={1}
                                      className="border border-white px-4 py-2 font-bold"
                                    >
                                      {product.allocation
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                      %
                                    </td>
                                    <td
                                      colSpan={1}
                                      className="border border-white px-4 py-2 font-bold"
                                    >
                                      {product.invested_amount
                                        .toFixed(2)
                                        .toString()
                                        .replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ","
                                        ) || "-"}
                                    </td>
                                    <td
                                      colSpan={1}
                                      className="border border-white bg-[#F4D580] px-4 py-2 font-bold"
                                    ></td>
                                    <td
                                      colSpan={1}
                                      className="border border-white bg-[#F8C5C5] px-4 py-2 font-bold"
                                    ></td>
                                    <td
                                      colSpan={1}
                                      className="border border-white px-4 py-2 font-bold"
                                    ></td>
                                    <td
                                      colSpan={1}
                                      className="border border-white px-4 py-2 font-bold"
                                    ></td>
                                  </tr>

                                  {/* Stocks */}
                                  {product.stocks.map((stock, stockIndex) => (
                                    <tr
                                      key={stockIndex}
                                      className={`text-[#black] ${
                                        categoryData.category.name.toUpperCase() ==
                                        "GROWTH"
                                          ? "bg-[#E6F3FC]"
                                          : "bg-[#E7F5E8]"
                                      }`}
                                    >
                                      <td className="border border-white px-4 py-2"></td>
                                      <td className="border border-white px-4 py-2">
                                        {stock.name}
                                      </td>
                                      <td className="border border-white px-4 py-2">
                                        {stock.asx_code}
                                      </td>
                                      <td className="border border-white px-4 py-2">
                                        {stock.allocation.toFixed(2)}%{" "}
                                        {!stock.allocation ? "-" : ""}
                                      </td>
                                      <td className="border border-white px-4 py-2">
                                        {stock.allocated_amount
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          ) || "-"}
                                      </td>
                                      <td className="border border-white bg-[#F4D580]  px-4 py-2">
                                        {stock.unit_price.toFixed(2) || "-"}
                                      </td>
                                      <td className="border border-white bg-[#F8C5C5] px-4 py-2">
                                        {stock.number_of_shares.toLocaleString()}
                                      </td>
                                      <td className="border border-white px-4 py-2">
                                        {stock.actual_invested_amount
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          ) || "-"}
                                      </td>
                                      <td className="border border-white px-4 py-2">
                                        {stock.brokerage_fee.toFixed(2)}%{" "}
                                        {!stock.brokerage_fee ? "-" : ""}
                                      </td>
                                    </tr>
                                  ))}
                                </React.Fragment>
                              )
                            )}
                            <tr
                              className={`font-bold ${
                                categoryData.category.name.toUpperCase() ==
                                "GROWTH"
                                  ? "bg-[#92C5EA]"
                                  : "bg-[#A9D4AB]"
                              }`}
                            >
                              <td colSpan={1} className="border px-4 py-2"></td>
                              <td colSpan={2} className="border px-4 py-2">
                                SUB-TOTAL {categoryData.category.name}
                              </td>
                              <td colSpan={1} className="border px-4 py-2">
                                {categoryData.category.allocation || "-"}
                              </td>
                              <td colSpan={1} className="border px-4 py-2">
                                {categoryData.category.allocation || "-"}
                              </td>
                              <td
                                colSpan={1}
                                className="border bg-[#F4D580]  px-4 py-2"
                              ></td>
                              <td
                                colSpan={1}
                                className={`border px-4 py-2 ${
                                  categoryData.category.name.toUpperCase() ==
                                  "GROWTH"
                                    ? "bg-[#F8C5C5]"
                                    : ""
                                }`}
                              ></td>
                              <td
                                colSpan={1}
                                className="border px-4 py-2 text-right"
                              >
                                {categoryData.category.invested_amount.toFixed(
                                  2
                                ) || "-"}
                              </td>
                              <td
                                colSpan={1}
                                className="border px-4 py-2 text-right"
                              ></td>
                            </tr>

                            {categoryData.category.name.toUpperCase() ==
                              "GROWTH" && (
                              <tr className="bg-[#EAEAEA] font-bold">
                                <td
                                  colSpan={1}
                                  className="border px-4 py-2 text-right"
                                ></td>
                                <td
                                  colSpan={2}
                                  className="border px-4 py-2"
                                ></td>
                                <td
                                  colSpan={1}
                                  className="border px-4 py-2"
                                ></td>
                                <td
                                  colSpan={1}
                                  className="border px-4 py-2"
                                ></td>
                                <td
                                  colSpan={1}
                                  className="border   px-4 py-2 text-right"
                                ></td>
                                <td
                                  colSpan={1}
                                  className="border px-4 py-2 text-right"
                                ></td>
                                <td
                                  colSpan={1}
                                  className="border px-4 py-2 text-right"
                                ></td>
                                <td
                                  colSpan={1}
                                  className="border px-4 py-2 text-right"
                                ></td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                        <React.Fragment>
                          <tr className="bg-[#EAEAEA] font-bold">
                            <td
                              colSpan={1}
                              className="border px-4 py-2 text-right"
                            ></td>
                            <td colSpan={2} className="border px-4 py-2">
                              Summary
                            </td>
                            <td colSpan={1} className="border px-4 py-2"></td>
                            <td colSpan={1} className="border px-4 py-2"></td>
                            <td
                              colSpan={1}
                              className="border bg-[#F4D580]  px-4 py-2 text-right"
                            ></td>
                            <td
                              colSpan={1}
                              className="border px-4 py-2 text-right"
                            ></td>
                            <td
                              colSpan={1}
                              className="border px-4 py-2 text-right"
                            ></td>
                            <td
                              colSpan={1}
                              className="border px-4 py-2 text-right"
                            ></td>
                          </tr>
                          <tr className="bg-[#92C5EA]  font-bold">
                            <td
                              colSpan={1}
                              className="border px-4 py-2 text-right"
                            ></td>
                            <td colSpan={2} className="border px-4 py-2">
                              {portfolioData[0].category.name}
                            </td>
                            <td colSpan={1} className="border px-4 py-2">
                              {portfolioData[0].category.allocation || "-"}
                            </td>
                            <td colSpan={1} className="border px-4 py-2">
                              {portfolioData[0].category.allocation || "-"}
                            </td>
                            <td
                              colSpan={1}
                              className="border bg-[#F4D580]  px-4 py-2"
                            ></td>
                            <td colSpan={1} className="border px-4 py-2"></td>
                            <td colSpan={1} className="border px-4 py-2">
                              {portfolioData[0].category.invested_amount.toFixed(
                                2
                              ) || "-"}
                            </td>
                            <td colSpan={1} className="border px-4 py-2 ">
                              {portfolioData[0].category.brokerage_fee || "-"}
                            </td>
                          </tr>
                          <tr className="bg-[#A9D4AB] font-bold">
                            <td colSpan={1} className="border px-4 py-2 "></td>
                            <td colSpan={2} className="border px-4 py-2">
                              {portfolioData[1].category.name}
                            </td>
                            <td colSpan={1} className="border px-4 py-2">
                              {portfolioData[1].category.allocation || "-"}
                            </td>
                            <td colSpan={1} className="border px-4 py-2">
                              {portfolioData[1].category.allocation || "-"}
                            </td>
                            <td
                              colSpan={1}
                              className="border bg-[#F4D580]  px-4 py-2 text-right"
                            ></td>
                            <td colSpan={1} className="border px-4 py-2"></td>
                            <td colSpan={1} className="border px-4 py-2">
                              {portfolioData[1].category.invested_amount.toFixed(
                                2
                              ) || "-"}
                            </td>
                            <td colSpan={1} className="border px-4 py-2">
                              {portfolioData[1].category.brokerage_fee || "-"}
                            </td>
                          </tr>
                          <tr className="bg-[#CDCDCD] font-bold">
                            <td colSpan={1} className="border px-4 py-2"></td>
                            <td colSpan={2} className="border px-4 py-2">
                              TOTAL PORTFOLIO
                            </td>
                            <td colSpan={1} className="border px-4 py-2">
                              {portfolioData[0].category.allocation +
                                portfolioData[1].category.allocation || "-"}
                            </td>
                            <td colSpan={1} className="border px-4 py-2">
                              {portfolioData[0].category.allocation +
                                portfolioData[1].category.allocation || "-"}
                            </td>
                            <td
                              colSpan={1}
                              className="border bg-[#F4D580]  px-4 py-2"
                            ></td>
                            <td colSpan={1} className="border px-4 py-2"></td>
                            <td colSpan={1} className="border px-4 py-2">
                              {(
                                portfolioData[0].category.invested_amount +
                                portfolioData[1].category.invested_amount
                              ).toFixed(2) || "-"}
                            </td>
                            <td colSpan={1} className="border px-4 py-2"></td>
                          </tr>
                        </React.Fragment>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {filter == "details" && (
          <div className="w-full  p-4 bg-white rounded-lg shadow-lg">
            <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
              <h1 className="text-lg font-medium mb-2">
                Caprock Model Portfolio - Alternative Growth
              </h1>
            </div>
            <div className="mt-2 border rounded-md">
              <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                <h1 className="text-md font-medium mb-2 text-black text-center">
                  Basic Details
                </h1>
                {/* Edit Icon on the Right */}
                <img
                  onClick={togglePopup}
                  src="/edit-details.svg" // Replace with the actual path to your edit icon
                  alt="Edit Icon"
                  className="w-4 h-4 cursor-pointer"
                />
              </div>
              {isOpen && (
                <div className="fixed inset-0   flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-lg w-[90%] max-w-[700px] p-6 max-h-screen overflow-y-auto">
                    {/* Modal Header */}
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-lg font-medium text-center w-full">
                        Caprock Model Portfolio -{" "}
                        <br className="hidden md:block" /> Alternative Growth
                      </h2>
                      <button onClick={togglePopup}>
                        <img
                          src="/add.svg"
                          alt="Close"
                          className="w-8 h-8 md:w-10 md:h-10"
                        />
                      </button>
                    </div>

                    {/* Modal Content */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* Left Side */}
                      <div className="space-y-4">
                        <Dropdown
                          label="Investment Manager"
                          options={users}
                          onSelect={handleSelectInvestmentManager}
                          preselectedValue={preselectedManager}
                        />

                        <Dropdown
                          label="Change Account"
                          options={InvestmentManagerAccountData}
                          onSelect={handleSelectInvestmentManagerAccount}
                          preselectedValue={preselectedManagerAccount}
                        />

                        <Dropdown
                          label="Select Advisor"
                          options={users}
                          onSelect={handleSelectAdvisor}
                          preselectedValue={preselectedAdvisor}
                        />

                        <Dropdown
                          label="Change Account"
                          options={AdvisorAccountData}
                          onSelect={handleSelectAdvisorAccount}
                          preselectedValue={preselectedAdvisorAccount}
                        />
                      </div>

                      {/* Right Side */}
                      <div className="space-y-4">
                        <Dropdown
                          label="Sub Advisor"
                          options={users}
                          preselectedValue={preselectedSubAdvisor}
                          onSelect={handleSelectSubAdvisor}
                        />

                        <Dropdown
                          label="Change Account"
                          options={SubAdvisorAccountData}
                          onSelect={handleSelectSubAdvisorAccount}
                          preselectedValue={preselectedSubAdvisorAccount}
                        />

                        <Dropdown
                          label="Platform"
                          options={users}
                          onSelect={handleSelectPlatform}
                          preselectedValue={preselectedPlatform}
                        />

                        <Dropdown
                          label="Settlement Account"
                          options={SettlementAccountData}
                          onSelect={handleSelectSettlementAccount}
                          preselectedValue={preselectedPlatformAccount}
                        />
                      </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="flex flex-col md:flex-row justify-center md:space-x-4 space-y-2 md:space-y-0 mt-6">
                      <button
                        onClick={togglePopup}
                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                      >
                        Cancel
                      </button>
                      <button
                        disabled={isNewChange}
                        onClick={handleCreateInvestment}
                        className={`px-6 py-2 rounded-lg ${
                          isNewChange
                            ? "bg-gray-400"
                            : "bg-black text-white hover:bg-gray-800"
                        }`}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="refId"
                    className="mb-1 text-sm text-[#A6A6A6]"
                  >
                    Ref ID
                  </label>
                  <span>{refId}</span>
                  <div className="mt-4">
                    <label
                      htmlFor="investmentType"
                      className="mb-1 text-sm text-[#A6A6A6]"
                    >
                      strategy Type
                    </label>
                    <div>{strategyType}</div>
                  </div>
                  <div className="mt-4">
                    <label
                      htmlFor="investmentType"
                      className="mb-1  text-sm text-[#A6A6A6]"
                    >
                      Risk Profile
                    </label>
                    <div>{riskProfile}</div>
                  </div>
                  <label
                    htmlFor="investmentType"
                    className="mb-1 mt-4 text-sm text-[#A6A6A6]"
                  >
                    Investment Type
                  </label>
                  <div>{investmentType}</div>
                </div>
                {/* center column */}
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Investment Manager</span>
                  </label>
                  <div>{investmentManagerNamefromAPI}</div>

                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">
                      Investment Manager Settlement Account
                    </span>
                  </label>
                  <span>{investmentManagerAccountfromAPI}</span>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Sub Advisor</span>
                  </label>
                  <div>{subadvisorIdfromAPI}</div>

                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">
                      Sub Advisor Settlement Account
                    </span>
                  </label>
                  <div>{subAdvisorAccountfromAPI}</div>
                </div>
                {/* Left column */}
                <div className="flex lg:pt-4 pt-0 flex-col px-4">
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Advisor</span>
                  </label>
                  <div>{advisorIdfromAPI}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">
                      Advisor Settlement Account
                    </span>
                  </label>
                  <div>{advisorAccountfromAPI}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Entity</span>
                  </label>
                  <div>{platformIdfromAPI}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Settlement Account</span>
                  </label>
                  <div>{platformAccountfromAPI}</div>
                </div>
              </div>

              {/* Fund Objective & Process Section */}
              <div className="mt-6 mb-4 px-4">
                <label
                  htmlFor="fundObjective"
                  className="block mb-1 text-sm text-[#A6A6A6]"
                >
                  Fund Objective & Process
                </label>
                <div
                  dangerouslySetInnerHTML={{ __html: fundObjectives }}
                  className="text-sm"
                ></div>
              </div>
            </div>
          </div>
        )}

        {filter == "details" && (
          <div className="w-full p-4 mt-6 bg-white rounded-lg shadow-lg">
            <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
              <h1 className="text-lg font-medium mb-2">
                Caprock Model Portfolio - Alternative Growth
              </h1>
            </div>
            <div className="mt-2 border  rounded-md">
              <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                <h1 className="text-md font-medium mb-2 text-black text-center">
                  Investment Details
                </h1>
                {/* Edit Icon on the Right */}
                <img
                  onClick={togglePopupEdit}
                  src="/edit-details.svg"
                  alt="Edit Icon"
                  className="w-4 h-4 cursor-pointer"
                />
              </div>
              {isOpenEdit && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white rounded-lg w-[90%] md:w-[700px] p-6">
                    {/* Modal Header */}
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-lg font-medium text-center w-full">
                        Caprock Model Portfolio - <br /> Alternative Growth
                      </h2>
                      <button onClick={togglePopupEdit}>
                        <img src="/add.svg" alt="Close" className="w-10 h-10" />
                      </button>
                    </div>

                    {/* Modal Body */}
                    <div className="grid grid-cols-1 gap-6 items-center">
                      <div className="space-y-4 mx-auto max-w-sm">
                        {" "}
                        <div>
                          <label
                            htmlFor="smaFees"
                            className="block mb-1 text-sm"
                          >
                            <span className="text-labelColour">SMA Fees %</span>
                            <br />
                            <span className="text-[#868686] text-xs">
                              Including GST
                            </span>
                          </label>
                          <div className="relative">
                            <input
                              type="number"
                              value={smaFeesUpdate}
                              onChange={(e) => {
                                setsmaFeesUpdate(e.target.value);
                                setisNewChangeFees(false);
                              }}
                              className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md block"
                            />
                            <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                              %
                            </span>
                          </div>
                        </div>
                        {/* Investment Manager Fees */}
                        <div>
                          <label
                            htmlFor="investmentFees"
                            className="block mb-1 text-sm"
                          >
                            <span className="text-labelColour">
                              Investment Manager Fees %
                            </span>
                            <br />
                            <span className="text-[#868686] text-xs">
                              Weighted Average
                            </span>
                          </label>
                          <div className="relative">
                            <input
                              type="number"
                              value={managerFeesUpdate}
                              onChange={(e) => {
                                setmanagerFeesUpdate(e.target.value);
                                setisNewChangeFees(false);
                              }}
                              className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md block"
                            />
                            <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                              %
                            </span>
                          </div>
                        </div>
                        {/* Sub Advisor Fees */}
                        <div>
                          <label
                            htmlFor="subAdvisorFees"
                            className="block mb-1 text-sm"
                          >
                            <span className="text-labelColour">
                              Advisor Fees %
                            </span>
                          </label>
                          <div className="relative">
                            <input
                              type="number"
                              value={advisorFeesUpdate}
                              onChange={(e) => {
                                setadvisorFeesUpdate(e.target.value);
                                setisNewChangeFees(false);
                              }}
                              className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md block"
                            />
                            <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                              %
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="flex justify-center space-x-4 mt-6">
                      <button
                        onClick={togglePopupEdit}
                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                      >
                        Cancel
                      </button>
                      <button
                        disabled={isNewChangeFees}
                        onClick={handleCreateInvestment}
                        className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <div className="grid grid-cols-1 sm:grid-cols-2 mb-4 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="refId"
                    className="mb-1 text-sm text-[#A6A6A6]"
                  >
                    Code
                  </label>
                  <span>{refId}</span>
                  <div className="mt-4">
                    <label
                      htmlFor="investmentType"
                      className="mb-1 text-sm text-[#A6A6A6]"
                    >
                      Investment Product Name
                    </label>
                    <div>{investmentProductName}</div>
                  </div>
                  <div className="mt-4">
                    <label
                      htmlFor="investmentType"
                      className="mb-1  text-sm text-[#A6A6A6]"
                    >
                      Risk Rating
                    </label>
                    <div>{riskRating}</div>
                  </div>
                  <div className="mt-4">
                    <label
                      htmlFor="investmentType"
                      className="mb-1  text-sm text-[#A6A6A6]"
                    >
                      Advisor Fees %
                    </label>
                    <div>{advisorFees}</div>
                  </div>
                </div>
                {/* center column */}
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <div className="grid grid-cols-2 gap-4">
                    {/* Growth (%) */}
                    <div>
                      <label className="block text-sm text-[#A6A6A6]">
                        Growth (%)
                      </label>
                      <div className="relative">{growth}</div>
                    </div>

                    {/* Defensive (%) */}
                    <div>
                      <label className="block text-sm text-[#A6A6A6]">
                        Defensive (%)
                      </label>
                      <div className="relative">{defensive}</div>
                    </div>
                  </div>

                  {/* Investments */}
                  <div>
                    <label className="block mb-1 mt-4 text-sm text-[#A6A6A6]">
                      Investments
                    </label>
                    <div className="mt-1   flex flex-wrap gap-2">
                      {investments.map((investment, index) => (
                        <div
                          key={index}
                          className="flex items-center bg-[#FCFCFC] text-gray-700 text-sm px-3 py-1 rounded-lg border shadow-sm"
                        >
                          <span>{investment}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="mt-4">
                    <label
                      htmlFor="investmentType"
                      className="mb-1  text-sm text-[#A6A6A6]"
                    >
                      SMA Fees % | Including GST
                    </label>
                    <div>{smaFees}</div>
                  </div>
                </div>
                {/* Left column */}
                <div className="flex lg:pt-4 pt-0 flex-col px-4">
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 text-sm"
                  >
                    <span className="text-[#A6A6A6]">
                      Investment Manager Fees % | Weighted Average
                    </span>
                  </label>
                  <div>{managerFees}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Sub Advisor Fees %</span>
                  </label>
                  <div>{subadvisorFees}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">
                      Strategy Inception Date
                    </span>
                  </label>
                  <div>{strategyDate}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 text-sm"
                  >
                    <span className="text-[#A6A6A6]">
                      Minimum Investment Amount
                    </span>
                  </label>
                  <div>{minimumInvestedAmount}</div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="flex items-center mt-6 p-4 bg-[#005A9C]">
          {/* Left Section: Back Button */}
          <div className="flex items-center justify-start w-full space-x-4">
            <div
              onClick={() => {
                let redirectState = {
                  path: "/investment-request-list",
                  state: {
                    from: location.pathname,
                  },
                };
                sessionStorage.setItem(
                  "redirectAfterLogin",
                  JSON.stringify(redirectState)
                );
                navigate("/investment-request-list");
              }}
              className="flex items-center space-x-2 text-sm md:text-md font-medium py-1 px-8 text-white cursor-pointer"
            >
              {/* Image on the left */}
              <img
                src="/white-arrow-back.svg" // Path to your image
                alt="Back Icon"
                className="w-4 h-4"
              />
              <span>Back</span>
            </div>
          </div>

          {/* Right Section: Download Button */}
          {filter == "view" && (
            <div className="flex items-center justify-end w-full">
              <button
                onClick={() => console.log("Download triggered")}
                className="flex items-center space-x-2 bg-white text-black font-medium py-2 px-4 rounded-full text-sm hover:bg-gray-200"
              >
                <span>Download</span>
              </button>
            </div>
          )}
          {!isCurrentInvestorSelected && filter == "investors" && (
            <div className="flex items-center justify-end w-full">
              <button
                onClick={() => console.log("Download triggered")}
                className="flex items-center space-x-2 bg-white text-black font-medium py-2 px-4 rounded-full text-sm hover:bg-gray-200"
              >
                <span>Purchase Portfolio</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InvestmentProductDetails;
